export default "__VITE_ASSET__ZwzH1DGY__"